import React, { useState } from "react";
import { Box } from "@mui/material";
import PropTypes from "prop-types";
import styles from "./Tabs.module.css";

const Tabs = ({ className = "", tabs, onTabChange }) => {
  const [activeTab, setActiveTab] = useState(tabs[0]);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    if (onTabChange) onTabChange(tab);
  };

  return (
    <Box className={[styles.tabs, className].join(" ")}>
      <Box className={styles.navigationTab}>
        {tabs.map((tab) => (
          <div
            key={tab}
            className={`${styles.tab} ${tab === activeTab ? styles.activeTab : ""}`}
            onClick={() => handleTabClick(tab)}
          >
            {tab}
          </div>
        ))}
      </Box>
    </Box>
  );
};

Tabs.propTypes = {
  className: PropTypes.string,
  tabs: PropTypes.arrayOf(PropTypes.string).isRequired,
  onTabChange: PropTypes.func,
};

export default Tabs;